// extracted by mini-css-extract-plugin
export var accordeonItem = "t_8";
export var body = "t_bb";
export var heading = "t_bc";
export var opened = "t_N";
export var small = "t_bd";
export var stat = "t_9";
export var svg = "t_Z";